'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.install = install;

var _utils = require('./utils');

var _errors = require('./errors');

var _loop = require('./loop');

var _effects = require('./effects');

/**
 * Lifts a reducer to always return a looped state.
 */
function liftReducer(reducer) {
  return function (state, action) {
    var result = reducer((0, _loop.getModel)(state), action);
    return (0, _loop.liftState)(result);
  };
}

/**
 * Installs a new dispatch function which will attempt to execute any effects
 * attached to the current model as established by the original dispatch.
 */
function install() {
  return function (next) {
    return function (reducer, initialState) {
      var liftedInitialState = (0, _loop.liftState)(initialState);
      var store = next(liftReducer(reducer), liftedInitialState);

      function dispatch(action) {
        var dispatchedAction = store.dispatch(action);
        var effect = (0, _loop.getEffect)(store.getState());
        return runEffect(action, effect).then(function () {});
      }

      function runEffect(originalAction, effect) {
        return (0, _effects.effectToPromise)(effect).then(function (actions) {
          var materializedActions = actions;
          return Promise.all(materializedActions.map(dispatch));
        })['catch'](function (error) {
          console.error((0, _errors.loopPromiseCaughtError)(originalAction.type));
          throw error;
        });
      }

      function getState() {
        return (0, _loop.getModel)(store.getState());
      }

      function replaceReducer(r) {
        return store.replaceReducer(liftReducer(r));
      }

      runEffect({ type: "@@ReduxLoop/INIT" }, (0, _loop.getEffect)(liftedInitialState));

      return _extends({}, store, {
        getState: getState,
        dispatch: dispatch,
        replaceReducer: replaceReducer
      });
    };
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-loop/lib/install.js
 ** module id = 234
 ** module chunks = 0
 **/